module.exports = __webpack_public_path__ + "static/img/20.abe179a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/20.png
// module id = di+j
// module chunks = 0